import { render, staticRenderFns } from "./HotelOrders.vue?vue&type=template&id=a33404dc&"
import script from "./HotelOrders.vue?vue&type=script&lang=js&"
export * from "./HotelOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports